import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Seguridad',
                icon: 'pi pi-home',
                items: [
                    {
                        label: 'Aplicaciones',
                        icon: 'pi pi-fw pi-prime',
                        routerLink: ['/pages/application']
                    }
                ]
            }
        ];
    }
}
